import type { ListBuilderList } from '../../../types';
import { createClientCartColumns } from '../columns';
import { CART_MOBILE_CARD_CONFIG, CART_REQUIRED_FIELDS } from '../shared';

/**
 * The client cart's line list. One list, no named tabs — a cart is a single
 * working set, not something you keep saved views of.
 *
 * `defaultSortId` keeps the endpoint's own order (line number, then id), which
 * is what the cart showed before it became a table.
 */
export const clientCartDefaultList: ListBuilderList = {
	id: 'client_cart_default',
	name: 'Cart Items',
	type: 'default',
	active: true,
	sortOrder: 0,
	columns: createClientCartColumns(),
	description: 'Lines in the client cart',
	requiredFields: CART_REQUIRED_FIELDS,
	mobileCardConfig: CART_MOBILE_CARD_CONFIG,
};
